import {Component, Input, OnInit} from '@angular/core';
import {AppService} from '../../../../services/app.service';

@Component({
  selector: 'app-poll-history',
  templateUrl: './poll-history.component.html',
  styleUrls: ['../live-matches.component.css', './poll-history.component.css']
})
export class PollHistoryComponent implements OnInit {

  public pollData;

  @Input()
  get data(): string {
    return this.pollData;
  }

  set data(data: any) {
    this.pollData = data;
  }

  constructor(
    public appService: AppService
  ) {
  }

  ngOnInit(): void {
  }

}
